import React from 'react'

const ServiceIconNine = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" fill="none">
            <g clipPath="url(#clip0_419_47)">
                <mask id="mask0_419_47" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="90" height="90">
                    <path d="M90 0H0V90H90V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_419_47)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M59.4612 74.0416C55.0944 81.3199 49.8136 84.6 45 84.6C40.1862 84.6 34.9055 81.3199 30.5386 74.0416C26.2361 66.8709 23.4 56.6158 23.4 45C23.4 33.384 26.2361 23.1292 30.5386 15.9585C34.9055 8.68027 40.1862 5.4 45 5.4C49.8136 5.4 55.0944 8.68027 59.4612 15.9585C63.7636 23.1292 66.6 33.384 66.6 45C66.6 56.6158 63.7636 66.8709 59.4612 74.0416ZM90 45C90 20.1472 69.8526 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8526 20.1472 90 45 90C69.8526 90 90 69.8526 90 45ZM5.4 45C5.4 61.1685 15.0897 75.0735 28.9788 81.225C22.3192 73.03 18 59.8559 18 45C18 30.1443 22.3192 16.9699 28.9788 8.77477C15.0897 14.9265 5.4 28.8317 5.4 45ZM84.6 45C84.6 61.1685 74.9101 75.0735 61.0213 81.225C67.6809 73.03 72 59.8559 72 45C72 30.1443 67.6809 16.9699 61.0213 8.77477C74.9101 14.9265 84.6 28.8317 84.6 45ZM45 49.95C47.7337 49.95 49.95 47.7337 49.95 45C49.95 42.2662 47.7337 40.05 45 40.05C42.2662 40.05 40.05 42.2662 40.05 45C40.05 47.7337 42.2662 49.95 45 49.95Z" fill="url(#paint0_linear_419_47)" />
                </g>
            </g>
            <defs>
                <linearGradient id="paint0_linear_419_47" x1="45" y1="0" x2="45" y2="90" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#B8DBFC" />
                    <stop offset="1" stopColor="#F8FBFE" />
                </linearGradient>
                <clipPath id="clip0_419_47">
                    <rect width="90" height="90" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ServiceIconNine